import { LocationQuery } from 'vue-router';
import { http } from '../../../helpers/http.helper';
import { ApiResource } from '../../../models/api-resource.interface';
import { SettingsGroupKey } from './settings-group-key.interface';

export class SettingsGroupKeyService {
   async getSettingsGroupKeys(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<SettingsGroupKey>>>(`/settings_group_keys`, { params: { ...query } });
      return response.data;
   }
}
